import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homecarousel',
  templateUrl: './homecarousel.component.html',
  styleUrls: ['./homecarousel.component.css']
})
export class HomecarouselComponent implements OnInit {
  currentSlide = 0;
    currentProductSlide = 0;
  currentVideoSlide = 0;
  timers: any[] = [];
  constructor() { }

  ngOnInit(): void {
      this.timers.push(setInterval(() => this.currentSlide = (this.currentSlide + 1) % 4, 5000));
    this.timers.push(setInterval(() => this.currentProductSlide = (this.currentProductSlide + 1) % 7, 3000));
    this.timers.push(setInterval(() => this.currentVideoSlide = (this.currentVideoSlide + 1) % 2, 4000));
  }

}
